import PopConfirm from './popConfirm';

export default PopConfirm;
